/**
 * Generated by orval. Do not edit manually.
 */

export type BrevoProposalStatus = (typeof BrevoProposalStatus)[keyof typeof BrevoProposalStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrevoProposalStatus = {
  PROPOSED: 'PROPOSED',
  DISMISSED: 'DISMISSED',
  APPLIED: 'APPLIED',
  LIVE: 'LIVE',
  MEASURED: 'MEASURED',
  ARCHIVED: 'ARCHIVED',
} as const
